import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FiSearch,
  FiRefreshCw,
  FiDownload,
  FiCheckCircle,
  FiXCircle,
  FiAlertCircle,
  FiClock,
  FiLink,
} from "react-icons/fi";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";

export default function WebhooksJobs() {
  const [searchTerm, setSearchTerm] = useState("");
  const [typeFilter, setTypeFilter] = useState("all");
  const [statusFilter, setStatusFilter] = useState("all");
  const [webhookPage, setWebhookPage] = useState(0);
  const [jobPage, setJobPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Static data - replace with API calls later
  const [webhooks] = useState([
    {
      id: 1,
      eventId: "WH-001",
      eventType: "Order Execution",
      endpoint: "https://api.partner.com/webhook/order",
      status: "Success",
      timestamp: "2024-01-20 10:30:15",
      retryCount: 0,
      responseCode: 200,
    },
    {
      id: 2,
      eventId: "WH-002",
      eventType: "Payment Webhook",
      endpoint: "https://api.partner.com/webhook/payment",
      status: "Failed",
      timestamp: "2024-01-20 09:15:22",
      retryCount: 2,
      responseCode: 500,
    },
    {
      id: 3,
      eventId: "WH-003",
      eventType: "Order Execution",
      endpoint: "https://api.partner.com/webhook/order",
      status: "Pending",
      timestamp: "2024-01-20 11:00:00",
      retryCount: 0,
      responseCode: null,
    },
  ]);

  const [jobs] = useState([
    {
      id: 1,
      jobId: "JOB-001",
      jobName: "Daily Sync",
      jobType: "Sync",
      status: "Completed",
      lastRun: "2024-01-20 06:00:00",
      nextRun: "2024-01-21 06:00:00",
      duration: "2m 15s",
    },
    {
      id: 2,
      jobId: "JOB-002",
      jobName: "Reconciliation",
      jobType: "Reconciliation",
      status: "Running",
      lastRun: "2024-01-20 08:00:00",
      nextRun: "2024-01-21 08:00:00",
      duration: "5m 30s",
    },
    {
      id: 3,
      jobId: "JOB-003",
      jobName: "Master Data Sync",
      jobType: "Sync",
      status: "Failed",
      lastRun: "2024-01-20 04:00:00",
      nextRun: "2024-01-21 04:00:00",
      duration: null,
    },
  ]);

  const handleRetryWebhook = (webhookId) => {
    Swal.fire({
      title: "Retry Webhook?",
      text: "This will retry the webhook processing.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Retry",
      confirmButtonColor: "#006e82",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Retrying...", "Webhook retry initiated.", "info");
      }
    });
  };

  const handleRerunJob = (jobId) => {
    Swal.fire({
      title: "Rerun Job?",
      text: "This will trigger the job to run immediately.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Rerun",
      confirmButtonColor: "#006e82",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Rerunning...", "Job rerun initiated.", "info");
      }
    });
  };

  const filteredWebhooks = webhooks.filter((webhook) => {
    const matchesSearch =
      webhook.eventId.includes(searchTerm) ||
      webhook.eventType.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === "all" || webhook.status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  const filteredJobs = jobs.filter((job) => {
    const matchesSearch =
      job.jobId.includes(searchTerm) ||
      job.jobName.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === "all" || job.status === statusFilter;
    const matchesType = typeFilter === "all" || job.jobType === typeFilter;
    return matchesSearch && matchesStatus && matchesType;
  });

  // Pagination for webhooks
  const webhookIndexOfLastItem = (webhookPage + 1) * itemsPerPage;
  const webhookIndexOfFirstItem = webhookIndexOfLastItem - itemsPerPage;
  const currentWebhooks = filteredWebhooks.slice(webhookIndexOfFirstItem, webhookIndexOfLastItem);
  const webhookPageCount = Math.ceil(filteredWebhooks.length / itemsPerPage);

  // Pagination for jobs
  const jobIndexOfLastItem = (jobPage + 1) * itemsPerPage;
  const jobIndexOfFirstItem = jobIndexOfLastItem - itemsPerPage;
  const currentJobs = filteredJobs.slice(jobIndexOfFirstItem, jobIndexOfLastItem);
  const jobPageCount = Math.ceil(filteredJobs.length / itemsPerPage);

  const handleWebhookPageClick = ({ selected }) => {
    setWebhookPage(selected);
  };

  const handleJobPageClick = ({ selected }) => {
    setJobPage(selected);
  };

  const handleItemsPerPageChange = (e) => {
    const newItemsPerPage = parseInt(e.target.value);
    setItemsPerPage(newItemsPerPage);
    setWebhookPage(0);
    setJobPage(0);
  };

  return (
    <>
      <div className="main-content">
        <div className="page-wrapper page-settings">
          <div className="content">
            {/* Breadcrumb and Header Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
                 <div className="content-page-header content-page-headersplit">
                 <h5>Webhooks & Jobs</h5>
                 </div>
              <nav
                aria-label="breadcrumb"
                style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <NavLink to="/dashboard">Dashboard</NavLink> /
                  </li>
                  <li className="breadcrumb-item">
                    <NavLink to="/admin/integrations/webhooks-jobs">Integrations</NavLink> /
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Webhooks & Jobs
                  </li>
                </ol>
              </nav>
           
             
            </div>

            {/* Filters Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
                <div className="d-flex justify-content-between align-items-center flex-wrap"> {/* Filters */} 
                  <div className="row g-2 flex-grow-1">
                <div className="col-12 col-md-4">
                  <div className="position-relative">
                    <FiSearch
                      style={{
                        position: "absolute",
                        left: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#64748b",
                        zIndex: 1,
                      }}
                    />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by ID, type, or name..."
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setWebhookPage(0);
                        setJobPage(0);
                      }}
                      style={{ paddingLeft: "40px" }}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <select
                    className="form-control"
                    value={statusFilter}
                    onChange={(e) => {
                      setStatusFilter(e.target.value);
                      setWebhookPage(0);
                      setJobPage(0);
                    }}
                  >
                    <option value="all">All Status</option>
                    <option value="Success">Success</option>
                    <option value="Failed">Failed</option>
                    <option value="Pending">Pending</option>
                    <option value="Running">Running</option>
                    <option value="Completed">Completed</option>
                  </select>
                </div>
                <div className="col-12 col-md-3">
                  <select
                    className="form-control"
                    value={typeFilter}
                    onChange={(e) => {
                      setTypeFilter(e.target.value);
                      setJobPage(0);
                    }}
                  >
                    <option value="all">All Types</option>
                    <option value="Sync">Sync</option>
                    <option value="Reconciliation">Reconciliation</option>
                  </select>
                </div>
                </div>
                <div className="ms-md-3 mt-3 mt-md-0">
                  <button className="btn btn-primary">
                    <i className="fas fa-download me-2"></i>
                    Export Logs
                  </button>
              </div>
              </div>
            </div>

            {/* Webhooks Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <h4 className="mb-4" style={{ color: "#006e82" }}>
                <i className="fas fa-link me-2"></i>
                Webhook Events
              </h4>
              <div className="row">
                <div className="col-12">
                  <div className="table-responsive">
                    <table className="table datatable">
                      <thead>
                        <tr>
                          <th>Event ID</th>
                          <th>Event Type</th>
                          <th>Endpoint</th>
                          <th>Status</th>
                          <th>Response Code</th>
                          <th>Retry Count</th>
                          <th>Timestamp</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentWebhooks.length === 0 ? (
                          <tr>
                            <td colSpan="8">No data available</td>
                          </tr>
                        ) : (
                          currentWebhooks.map((webhook) => (
                            <tr key={webhook.id}>
                              <td style={{ fontWeight: "500" }}>{webhook.eventId}</td>
                              <td>{webhook.eventType}</td>
                              <td style={{ fontFamily: "monospace", fontSize: "12px" }}>
                                {webhook.endpoint.substring(0, 40)}...
                              </td>
                              <td>
                                <span className={
                                  webhook.status === "Success" ? "badge-active" :
                                  webhook.status === "Failed" ? "badge-pending" :
                                  "badge-pending"
                                }>
                                  {webhook.status}
                                </span>
                              </td>
                              <td>{webhook.responseCode || "-"}</td>
                              <td>{webhook.retryCount}</td>
                              <td style={{ fontSize: "14px" }}>{webhook.timestamp}</td>
                              <td>
                                <div className="table-actions d-flex justify-content-center">
                                  {webhook.status === "Failed" && (
                                    <div
                                      className="delete-table"
                                      onClick={() => handleRetryWebhook(webhook.id)}
                                      title="Retry Webhook"
                                      style={{ cursor: "pointer" }}
                                    >
                                      <i className="fas fa-redo"></i>
                                    </div>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Webhooks Pagination */}
              {webhookPageCount > 1 && (
                <nav className="mt-4 pagination justify-content-end gap-2">
                  <select
                    className="form-select"
                    style={{ width: "70px", padding: "0 13px" }}
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <ReactPaginate
                    className="pagination justify-content-center"
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    pageCount={webhookPageCount}
                    pageClassName={"page-link"}
                    onPageChange={handleWebhookPageClick}
                    containerClassName={"pagination"}
                    previousLinkClassName={"page-link"}
                    nextLinkClassName={"page-link"}
                    disabledClassName={"disabled"}
                    activeClassName={"active"}
                  />
                </nav>
              )}
            </div>

            {/* Jobs Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <h4 className="mb-4" style={{ color: "#006e82" }}>
                <i className="fas fa-clock me-2"></i>
                Scheduled Jobs
              </h4>
              <div className="row">
                <div className="col-12">
                  <div className="table-responsive">
                    <table className="table datatable">
                      <thead>
                        <tr>
                          <th>Job ID</th>
                          <th>Job Name</th>
                          <th>Type</th>
                          <th>Status</th>
                          <th>Last Run</th>
                          <th>Next Run</th>
                          <th>Duration</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentJobs.length === 0 ? (
                          <tr>
                            <td colSpan="8">No data available</td>
                          </tr>
                        ) : (
                          currentJobs.map((job) => (
                            <tr key={job.id}>
                              <td style={{ fontWeight: "500" }}>{job.jobId}</td>
                              <td style={{ fontWeight: "500" }}>{job.jobName}</td>
                              <td>
                                <span className="badge" style={{
                                  background: "#f0f9ff",
                                  color: "#006e82",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                  fontWeight: "600",
                                }}>
                                  {job.jobType}
                                </span>
                              </td>
                              <td>
                                <span className={
                                  job.status === "Completed" ? "badge-active" :
                                  job.status === "Failed" ? "badge-pending" :
                                  job.status === "Running" ? "badge-pending" :
                                  "badge-pending"
                                }>
                                  {job.status}
                                </span>
                              </td>
                              <td style={{ fontSize: "14px" }}>{job.lastRun}</td>
                              <td style={{ fontSize: "14px" }}>{job.nextRun}</td>
                              <td>{job.duration || "-"}</td>
                              <td>
                                <div className="table-actions d-flex justify-content-center">
                                  <div
                                    className="delete-table"
                                    onClick={() => handleRerunJob(job.jobId)}
                                    title="Rerun Job"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i className="fas fa-redo"></i>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Jobs Pagination */}
              {jobPageCount > 1 && (
                <nav className="mt-4 pagination justify-content-end gap-2">
                  <select
                    className="form-select"
                    style={{ width: "70px", padding: "0 13px" }}
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <ReactPaginate
                    className="pagination justify-content-center"
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    pageCount={jobPageCount}
                    pageClassName={"page-link"}
                    onPageChange={handleJobPageClick}
                    containerClassName={"pagination"}
                    previousLinkClassName={"page-link"}
                    nextLinkClassName={"page-link"}
                    disabledClassName={"disabled"}
                    activeClassName={"active"}
                  />
                </nav>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
